import React, { useState } from "react";
import {
  Row,
  Col,
  Form,
  Label,
  Card,
  CardBody,
  CardTitle,
  Container,
  FormGroup,
  InputGroup,
  Input,
} from "reactstrap";

import Breadcrumbs from "../../../components/Common/Breadcrumb";
import InputSelectCustom from "../../../components/Common/InputSelectCustom";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/l10n/pt.js";
import Flatpickr from "react-flatpickr";

import SimpleBarFilterCustom from "../../../components/Common/SimpleBarFilterCustom";

const FormCustom = () => {
  document.title = "Form Customs | Defender";

  const [revenda, setRevenda] = useState();
  const [dataInicio, setDataInicio] = useState();
  const [produto, setProduto] = useState("");

  //filtros
  const [filterSelections, ] = useState({});
  const [isFiltrosOpen, setIsFiltrosOpen] = useState(false)
  const toggleFiltros = () => {
    setIsFiltrosOpen(!isFiltrosOpen);
  };

  const handleFilterSelect = (filters) => {
    console.log("handleFilterSelect")
    console.log(filters)
  }

  const optionGroup = [
    {
      label: "Picnic",
      options: [
        { label: "Mustard", value: "Mustard" },
        { label: "Ketchup", value: "Ketchup" },
        { label: "Relish", value: "Relish" },
      ],
    },
    {
      label: "Camping",
      options: [
        { label: "Tent", value: "Tent" },
        { label: "Flashlight", value: "Flashlight" },
        { label: "Toilet Paper", value: "Toilet Paper" },
      ],
    },
  ];

  const handleFilter = (e) => {
    e.preventDefault();
    console.log(e);
  };

  const handleSelectRevenda = (selectedGroup) => {
    setRevenda(selectedGroup);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Forms" breadcrumbItem="Form Customs" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    #1 - Formulário customizado para filtros
                  </CardTitle>
                  <Row className="mb-3">
                    <Col lg={12} className="form-custom01-filter">
                      <Form onSubmit={handleFilter}>
                        <div className="row">
                          <div className="col-3">
                            <FormGroup className="mb-3 w-100">
                              <Label>Revenda</Label>
                              <InputSelectCustom
                                name={"revenda"}
                                stateSelected={revenda}
                                optionsData={optionGroup}
                                placeholder="Todas"
                                handleOnChange={handleSelectRevenda}
                              />
                            </FormGroup>
                          </div>
                          <div className="col-3">
                            <FormGroup className="mb-4 w-100">
                              <Label>Data Início</Label>
                              <InputGroup>
                                <Flatpickr
                                  className="form-control d-block"
                                  onChange={(d) =>
                                    setDataInicio(new Date(d).toISOString())
                                  }
                                  value={dataInicio}
                                  placeholder="dd-mm-aaaa"
                                  options={{
                                    locale: "pt",
                                    altInput: true,
                                    altFormat: "d-m-Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </div>
                          <div className="col-3">
                            <FormGroup className="mb-4 w-100">
                              <Label>Produto</Label>
                              <InputGroup>
                                <Input
                                  onChange={(e) => setProduto(e.target.value)}
                                  name="produto"
                                  placeholder="texto"
                                  value={produto}
                                />
                              </InputGroup>
                            </FormGroup>
                          </div>
                          <div className="col-3 d-flex align-items-center">
                            <button
                              className="btn btn-info text-white w-100 p-0 font-size-16 btn-filter-submit"
                              type="submit"
                            >
                              Pesquisar
                            </button>
                          </div>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">#2 - SimpleBar Filter Form Custom</CardTitle>
                  <Row className="mb-3">
                    <Col lg={12}>
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        onClick={toggleFiltros}
                      >
                        <i className="mdi mdi-filter"></i> Abrir Filtro
                      </button>
                      <SimpleBarFilterCustom
                        isOpen={isFiltrosOpen}
                        onClose={toggleFiltros}
                        callbackFilter={handleFilterSelect}
                        filterSelections={filterSelections}
                        onResetFilter={() => {}}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormCustom;
